import { Grid } from "@mui/material";
import { SupplierFormProps } from "../SupplierFormProps";
import { SupplierAddressForm } from "./SupplierAddress";
import { SupplierCoordinatesForm } from "./SupplierCoordinatesForm";
import { SupplierGsdbForm } from "./SupplierGsdbForm";

export const SupplierForm = ({ disabledFields }: SupplierFormProps) => {
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={12}>
        <SupplierGsdbForm disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={9}>
        <SupplierAddressForm disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={3}>
        <SupplierCoordinatesForm disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
};
